import React, {useEffect, useRef} from 'react'

import NavigationLogo from "../../../navigation/components/logo/logo"
import NavigationPanelReorderGroup from "../../../navigation/components/reorder-group/reorder-group"
import NavigationStructure from "../../../../core/model2/navigation/navigation-structure"
import Navigation_Separator from "../../../navigation/buttons/separator"
import Navigation_MyAccountBtn from "../../../navigation/buttons/my-account"
import ErrorBoundary from "../../../../core/error-boundary"
import NavigationPanel_QuickSearch from "../../../navigation/components/search/search"
import Navigation_ButtonUpgrade from "../../../navigation/buttons/upgrade"
import NavigationSection from "../../../../core/model2/navigation/navigation-section"
import {UIType} from "../../@const";
import {NavigationButtonTypeClass} from "../../../navigation/@const";
import {NavigationButtonPosition} from "../../../../core/model2/navigation/@const";
import Navigation_ButtonSpace from "../../../navigation/buttons/generic-space";

type Props = {
    navigationStructure         : NavigationStructure
    onDragNavigationSectionsEnd : callback
    className?                  : string
    navWidth                    : number
}

// const debug = "NavigationPanel_Teams_User"
const debug = false

export default function NavigationPanel_Teams_User(props: Props) {

    const leftSectionRef    = useRef<HTMLDivElement>(null)
    const [showSearchInput, setShowSearchInput] = React.useState(true);
    const [navWidth, setNavWidth] = React.useState(0);
    debug && console.log(debug, "Render()")

    // extract home section, it is rendered separately and should not present among reorderable items
    const homeSection   = gd.spaces.home.navigation

    const spaces = gd.spaces.navigationPanelTopSpacesAsNavigations


    // const workspaces= props.navigationStructure.workspaces
    const views         = _.filter(props.navigationStructure.views, (navigationSection: NavigationSection) => {
        return !navigationSection.isInMore
    })

    const more          = props.navigationStructure.more
    const quickAdd      = props.navigationStructure.quickAdd
    const search        = props.navigationStructure.search
    const aiChat        = props.navigationStructure.aiChat

    // it can be undefined when chat disabled...
    // const chat      = props.navigationStructure.chat
    const chat          = gd.spaces.chats.navigation

    const showViews     = views.length > 0
    const showUpgrade   = !gd.company.license.isPaid
    const showSearchBtn = search && search.position !== NavigationButtonPosition.MORE && (gd.ui.type === UIType.LEFT || gd.ui.type === UIType.GOODDAY_MODERN || (gd.ui.type === UIType.TOP && !showSearchInput))
    const showSearchBig = gd.ui.type === UIType.TOP && showSearchInput

    useEffect(() => {
        setTimeout(()=>{
            const leftSectionWidth = leftSectionRef.current?.offsetWidth

            // 175 Eto polovina search input !!!!!!

            if (leftSectionWidth && props.navWidth/2 - leftSectionWidth > 175) {
                setShowSearchInput(true)
                setNavWidth(props.navWidth)
            } else {
                setShowSearchInput(false)
            }
        }, 0)

    }, [props.navWidth, spaces.length, views.length])

    const onReorder = (navigationSections: NavigationSection[]) => {
        debug && console.log(debug, "onReorder", navigationSections)

        gd.spaces.saveSpacesOrder(navigationSections)
    }

    const onViewsReorder = (navigationSections: NavigationSection[]) => {
        debug && console.log(debug, "onViewsReorder", navigationSections)

        props.onDragNavigationSectionsEnd(1, navigationSections)
    }

    // console.count("render navigation panel")

    return (
        <>
            <div ref={leftSectionRef} className="top">
                <div className="top-container">

                    <NavigationLogo/>


                    <ErrorBoundary>
                        <homeSection.renderComponent className={NavigationButtonTypeClass.IS_TAB}
                                                     section={homeSection}/>

                        <NavigationPanelReorderGroup sections={spaces} onDragEnd={onReorder}/>

                        <Navigation_Separator/>

                        {showViews &&
                            <>
                                <NavigationPanelReorderGroup sections={views}
                                                             onDragEnd={onViewsReorder}/>

                                <Navigation_Separator/>
                            </>
                        }


                        <more.renderComponent section={more}/>

                        {gd.spaces.quickAdd.inNavigationPanel &&
                            <quickAdd.renderComponent section={quickAdd}/>
                        }

                    </ErrorBoundary>
                </div>
            </div>


        </>
    )
}
